import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import {
  GridContainer,
  GridRow,
  GridColumn,
  Button,
  Img,
  Utils,
} from "arv-reactcomponents";

import staticEndpoints from "../../../../api/endPoints/staticEndpoints";

import Analytics from "../../../../analytics";
import Event from "../../../../analytics/eventFactory";

import {
  LoginActionButton,
  MyBagActionButton,
  StoreLocatorActionButton,
} from "../../ActionButtons";

import BrandNavContainer from "../BrandNavContainer";
import TopbarText from "../../TopbarText";
import { HOME_PAGE_URL } from "../../../../constants";

const BRAND_CLICK_ACTION = "nnnow_nav_click";

@inject("HeaderStore", "CommonStore")
@observer
class TopBar extends Component {
  static trackToggleBrandMenu() {
    Analytics.trackEvent({
      action: BRAND_CLICK_ACTION,
      label: Event.label.getSource(window.pageType),
      category: Event.category.TOP_ABOVE_MENU_CTR,
    });
  }

  constructor(props) {
    super(props);

    this.state = {
      isBrandMenuOpen: false,
    };

    this.toggleBrandMenu = this.toggleBrandMenu.bind(this);
  }

  get isFixedClassName() {
    return (this.props.HeaderStore.isFixed && "is-fixed") || "";
  }

  get hideIfNotBrandpageClassName() {
    return (!this.props.CommonStore.isBrandPage && "nwc-hide") || "";
  }

  get hideIfBrandpageClassName() {
    return (this.props.CommonStore.isBrandPage && "nwc-hide") || "";
  }

  toggleBrandMenu() {
    const isBrandMenuOpen = !this.state.isBrandMenuOpen;

    if (isBrandMenuOpen) {
      TopBar.trackToggleBrandMenu();
    }

    this.setState(
      {
        isBrandMenuOpen,
      },
      () => {
        if (this.state.isBrandMenuOpen) {
          Utils.fixScroll();
        } else {
          Utils.unFixScroll();
        }
      },
    );
  }

  render() {
    const { isBrandMenuOpen } = this.state;

    return (
      <GridContainer className={`nw-topbar ${this.isFixedClassName}`}>
        <GridRow className="nw-topbar-row">
          <GridColumn className="nw-topbar-col nw-topbar-colleft">
            <Button
              className={`
                nwc-btn-primary-txt
                nwc-btn-xs
                nw-topbar-brandmenu
                ${this.hideIfNotBrandpageClassName}
              `}
              onClick={this.toggleBrandMenu}
            >
              <i className="icomoon-menu" />
            </Button>
            <BrandNavContainer
              active={isBrandMenuOpen}
              onClose={this.toggleBrandMenu}
            />
            <a
              href={HOME_PAGE_URL}
              target="_self"
              className={`
                nw-topbar-logo-link
                ${this.hideIfNotBrandpageClassName}
              `}
            >
              <Img
                className="nw-topbar-logo"
                src={staticEndpoints.nnnowLogoUrl}
                alt="NNNOW image"
              />
            </a>
            <StoreLocatorActionButton
              className={this.hideIfBrandpageClassName}
              text="STORE LOCATOR"
            />
          </GridColumn>
          <GridColumn className="nw-topbar-col nw-topbar-colcenter">
            <TopbarText />
          </GridColumn>
          <GridColumn className="nw-topbar-col nw-topbar-colright">
            <StoreLocatorActionButton
              className={`nw-topbar-storelocator ${
                this.hideIfNotBrandpageClassName
              }`}
              text="STORE LOCATOR"
            />
            <LoginActionButton text="LOGIN" />
            <MyBagActionButton />
          </GridColumn>
        </GridRow>
      </GridContainer>
    );
  }
}

TopBar.wrappedComponent.propTypes = {
  HeaderStore: PropTypes.shape({
    isFixed: PropTypes.bool.isRequired,
  }).isRequired,
  CommonStore: PropTypes.shape({
    isBrandPage: PropTypes.bool,
  }).isRequired,
};

export default TopBar;



// WEBPACK FOOTER //
// ./src/component/Header/DesktopHeader/TopBar/index.js